/** Represents a list of date range preset keys used for quick date selection. */
export const searchFilterDateRangePresetKeys = [
    'today',
    'yesterday',
    'last_7_days',
    'last_4_weeks',
    'last_3_months',
];
